import React from 'react';

const UserRoundIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.0026 10.8333C12.3038 10.8333 14.1693 8.96785 14.1693 6.66667C14.1693 4.36548 12.3038 2.5 10.0026 2.5C7.70142 2.5 5.83594 4.36548 5.83594 6.66667C5.83594 8.96785 7.70142 10.8333 10.0026 10.8333Z"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.3333 17.6667C16.3333 15.8986 15.631 14.2029 14.3807 12.9526C13.1305 11.7024 11.4348 11 9.66667 11C7.89856 11 6.20286 11.7024 4.95262 12.9526C3.70238 14.2029 3 15.8986 3 17.6667"
      stroke="#616893"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserRoundIcon;
